import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./css/Testimonials.css";
import axios from "axios";
import { Testimonials_BASE_URL } from "../../configs/WebServiceUrl";

// const testimonialItems = [
//   {
//     name: "Arjun Sharma",
//     role: "Class 8",
//     org: "Delhi Public School, Mumbai",
//     rating: 5,
//     quote:
//       "DocMaster Quiz helped me improve my mathematics skills tremendously. The practice quizzes are amazing and I even won ₹2,000 in a live competition!",
//     tag: "Math Wizards Winner",
//     tagColor: "green",
//     avatar: "👦",
//   },
//   {
//     name: "Priya Patel",
//     role: "Class 10",
//     org: "St. Mary's Convent School",
//     rating: 5,
//     quote:
//       "I love the thematic quizzes! The Eco Warriors campaign made me more aware about environmental issues. The questions are challenging yet fun.",
//     tag: "Eco Warriors Champion",
//     tagColor: "green",
//     avatar: "👧",
//   },
//   {
//     name: "Dr. Rajesh Kumar",
//     role: "Principal",
//     org: "Bright Future Academy",
//     rating: 5,
//     quote:
//       "Excellent platform for our students! The school dashboard helps us track student progress and the bulk registration feature saves time. Highly recommended!",
//     tag: "School Excellence Award",
//     tagColor: "green",
//     avatar: "🧑‍🏫",
//   },
//   {
//     name: "Sneha Gupta",
//     role: "Class 6",
//     org: "Rainbow International School",
//     rating: 5,
//     quote:
//       "The science quizzes are my favorite! I learned so many new facts and the instant feedback helps me understand my mistakes. Can't wait for more quizzes!",
//     tag: "Science Explorer Badge",
//     tagColor: "green",
//     avatar: "👧",
//   },
//   {
//     name: "Rohan Singh",
//     role: "Class 9",
//     org: "Modern Public School",
//     rating: 5,
//     quote:
//       "Won my first scholarship through DocMaster Quiz! The platform is user-friendly and the questions are well-researched.",
//     tag: "Scholarship Winner",
//     tagColor: "green",
//     avatar: "👦",
//   },
//   {
//     name: "Mrs. Sunita Joshi",
//     role: "Teacher",
//     org: "Vidya Mandir High School",
//     rating: 5,
//     quote:
//       "As a teacher, I appreciate how this platform encourages competitive learning. My students are more engaged with their studies since they started using DocMaster Quiz.",
//     tag: "Teacher's Choice Award",
//     tagColor: "green",
//     avatar: "👩‍🏫",
//   },
//   {
//     name: "Aaditya Mehta",
//     role: "Class 7",
//     org: "International School of Excellence",
//     rating: 5,
//     quote:
//       "The multilingual support is fantastic! I can practice in both Hindi and English. The computer science quizzes helped me learn coding basics.",
//     tag: "Computer Champ",
//     tagColor: "green",
//     avatar: "👦",
//   },
//   {
//     name: "Kavya Reddy",
//     role: "Class 5",
//     org: "Little Flower School",
//     rating: 4,
//     quote:
//       "I enjoy the general knowledge quizzes the most. They cover such interesting topics! My parents are happy to see my improvement in current affairs.",
//     tag: "GK Master",
//     tagColor: "green",
//     avatar: "👧",
//   },
// ];

const stats = [
  { value: "10,000+", label: "Happy Students" },
  { value: "500+", label: "Registered Schools" },
  { value: "₹50,000+", label: "Prizes Distributed" },
  { value: "1,000+", label: "Success Stories" },
];

const featureBoxes = [
  {
    title: "Quiz Champions",
    desc: "Students who have excelled in competitive quizzes and won significant prizes",
    icon: "🏆",
    bg: "linear-gradient(90deg,#f3f6ff,#eef7ff)",
  },
  {
    title: "Academic Excellence",
    desc: "Students showing remarkable improvement in their academic performance",
    icon: "🎓",
    bg: "linear-gradient(90deg,#eefaf2,#f5fff6)",
  },
  {
    title: "School Success",
    desc: "Educational institutions achieving outstanding results with our platform",
    icon: "🏫",
    bg: "linear-gradient(90deg,#fff6f0,#fff6f0)",
  },
];

const Testimonials = () => {
  const TestimonialsList = `${Testimonials_BASE_URL}/api/school/syllabus/testmonials/published`;
  const [testimonialItems, setTestimonials] = useState([]);

  useEffect(() => {
    axios
      // .get(`${BASE_URL}/homepage/testimonials`)
      .get(TestimonialsList)
      .then((res) => setTestimonials(res.data?.data || []))
      .catch((err) => console.error("Error fetching testimonials:", err));
  }, []);

  return (
    <div className="testimonials-page">
      <header className="tm-header bg-light py-5">
        <div className="tm-container text-center">
          <div className="header-title">
            <h1>Student Testimonials</h1>
            <p>
              Hear from our amazing students, teachers, and schools about their
              DocMaster Quiz experience
            </p>
          </div>

          <div className="stats-row">
            {stats.map((s, idx) => (
              <div key={idx} className="stat-item">
                <div className="stat-value">{s.value}</div>
                <div className="stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </header>

      <main className="tm-container tm-main">
        <section className="testimonials-grid">
          {testimonialItems?.length > 0 &&
            testimonialItems?.map((t, i) => (
              <article key={i} className="testimonial-card">
                <div className="tc-top">
                  <div className="tc-avatar">{t.avatar}</div>
                  <div className="tc-person">
                    <div className="tc-name">{t.name}</div>
                    <div className="tc-sub">{t.role}</div>
                    <div className="tc-org">{t.org}</div>
                  </div>
                  <div className="tc-rating">
                    {Array.from({ length: t.rating }).map((_, r) => (
                      <span key={r} className="star">
                        ★
                      </span>
                    ))}
                  </div>
                </div>

                <div className="tc-quote">"{t.quote}"</div>

                <div className="tc-badge">{t.tag}</div>
              </article>
            ))}
        </section>

        <section className="features-row">
          {featureBoxes.map((f, idx) => (
            <div className="feature-box" key={idx} style={{ background: f.bg }}>
              <div className="feature-icon">{f.icon}</div>
              <h4 className="feature-title">{f.title}</h4>
              <p className="feature-desc">{f.desc}</p>
            </div>
          ))}
        </section>

        <section className="cta-box">
          <h3>Join Our Success Community</h3>
          <p>
            Be part of thousands of students achieving academic excellence
            through interactive learning
          </p>
          <div className="cta-actions">
            <button className="btn-primary large">Start Your Journey</button>
            <button className="btn-outline large">View Success Stories</button>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Testimonials;
